// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 3070 ? "8012d7e2" : chunkId) + "." + {"3070":"711fbfa5cb76ec03","6233":"c3eded97eef2020f"}[chunkId] + ".js";
};